import { request } from '@/utils/registerRequest'
export function register(data) {
    return request({
        url: '/api/v1/ctMember/member/register',
        method: 'post',
        data: {
            ...data
        }
    });
}

export function checkName(showName) {
    return request({
        url: '/api/v1/ctMember/member/verifyShowName',
        method: 'get',
        params: {
            showName
        }
    });
}

export function checkIdNumber(idNumber) {
    return request({
        url: '/api/v1/ctMember/member/verifyIdNumber',
        method: 'get',
        params: {
            idNumber
        }
    });
}
export function isCanRegister() {
    return request({
        url: '/api/v1/ctMember/member/isCanRegister',
        method: 'get',
    });
}

export function getDictValues(type) {
    return request({
        url: '/api/v1/ctMember/member/getDictValues',
        method: 'get',
        params: {
            type
        }
    });
}

